const AMBIENT_HOST = "ambienttpa.com"

/** A URL on Ambient's domain or one of its subdomains, such as the card frame's single-use session URL. */
export const AMBIENT_URL_PATTERN = /^https?:\/\/([\w-]+\.)*ambienttpa\.com(?=[:/?#]|$)/i

const AMBIENT_CARD_MESSAGE_SOURCE = "ambient-card"

const AMBIENT_CARD_ERROR_CODES = ["session_consumed", "invalid_token", "employee_not_provisioned"] as const

export type AmbientCardErrorCode = (typeof AMBIENT_CARD_ERROR_CODES)[number] | "unknown"

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

/**
 * Reads the error code from a message posted by Ambient's card iframe. Returns `null` for anything that is not an
 * Ambient error message, and `"unknown"` for an error whose code is missing or unrecognized.
 */
export function ambientCardErrorCode(data: unknown): AmbientCardErrorCode | null {
  if (!isRecord(data) || data.source !== AMBIENT_CARD_MESSAGE_SOURCE || data.type !== "error") return null

  const code = isRecord(data.payload) ? data.payload.code : undefined
  return AMBIENT_CARD_ERROR_CODES.find((known) => known === code) ?? "unknown"
}

/** The embed URL's origin, or `null` unless it is an `https:` URL on Ambient's domain and so safe to frame. */
export function ambientCardEmbedOrigin(embedUrl: string): string | null {
  let url: URL
  try {
    url = new URL(embedUrl)
  } catch {
    return null
  }
  const isAmbientHost = url.hostname === AMBIENT_HOST || url.hostname.endsWith(`.${AMBIENT_HOST}`)
  return url.protocol === "https:" && isAmbientHost ? url.origin : null
}
